<template>
  <v-container class="pb-0">
    <v-row class="ma-0">
      <v-col cols="2">
        <Filters :config="config"/>
      </v-col>
      <v-col class="pa-0" cols="10">
        <div v-if="loading" class="px-3 pt-6">
            <v-row v-for="n in itemsPerPage" :key="n" class="mb-6">
                <v-col cols="3" class="pa-0">
                <v-skeleton-loader class="" type="image"></v-skeleton-loader>
                </v-col>
                <v-col cols="9" class="pa-0">
                <v-skeleton-loader height="150px" type="subtitle, paragraph"></v-skeleton-loader>
                </v-col>
            </v-row>
        </div>
        <div v-else class="px-3 pt-3">
            <v-card v-for="(item, index) in data" :key="index" class="mb-6">
                <v-row no-gutters>
                <!-- Imagen -->
                <v-col cols="12" md="3">
                    <v-img
                    :src="item.featured_image"
                    height="220"
                    class="rounded-sm"
                    cover
                    ></v-img>
                </v-col>

                <!-- Detalles -->
                <v-col cols="12" md="9" class="pa-4">
                    <!-- Título y precio -->
                    <v-row>
                    <v-col>
                        <v-card-title>{{ item.title }}</v-card-title>
                    </v-col>
                    <v-col class="text-right">
                        <v-card-subtitle>
                            {{$toCurrency(item.discount_price != null ? item.discount_price : item.price)}}
                        </v-card-subtitle>
                        <v-card-subtitle v-if="item.discount_price != null" class="text-red text-decoration-line-through text-caption">
                        {{$toCurrency(item.price)}}
                        </v-card-subtitle>
                    </v-col>
                    </v-row>

                    <!-- Año, kilometraje, transmisión -->
                    <v-card-subtitle class="text-grey mt-2">
                    {{ item.year }}
                    <span class="px-2">/</span>
                    {{ Number(item.mileage).toLocaleString('es-MX') + ' km' }}
                    <span class="px-2">/</span>
                    {{ item.transmission }}
                    </v-card-subtitle>

                    <!-- Sucursal -->
                    <v-card-subtitle class="d-flex align-center text-caption mt-3">
                    <v-icon size="16" class="mr-1" color="grey">mdi-map-marker</v-icon>
                    <span>{{ item.branch?.name }}</span>
                    </v-card-subtitle>
                </v-col>
                </v-row>
            </v-card>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useLayoutStore } from '@/store/layout';
import { useLayoutField } from '@/composables/useLayoutField';
import Filters from '@/components/drawer/Filters.vue';
export default defineComponent({
  name: 'CardViewModule',
  components:{
    Filters
  },
  props: {
    moduleName: {
      type: String,
      required: true,
    },
    data: Array,
    config:Array
  },
  setup(props) {
    const layoutStore = useLayoutStore();
    const layout = layoutStore.getLayout(props.moduleName);

    const itemsPerPage = computed(() => layout.itemsPerPage);
    const loading = useLayoutField(props.moduleName, 'dataLoading');

    return {
      itemsPerPage,
      loading
    };
  }
});
</script>
